import React from 'react';
import { Box, Button, Card, Columns, Link, styled } from 'bumbag';
import format from 'date-fns/format';
import _find from 'lodash/find';
import _get from 'lodash/get';
import Loads from 'react-loads';

import { HealthFundDetails } from '@medipass/react-core';
import { ServiceDetails } from '@medipass/react-core';
import { ServiceItemDetails } from '@medipass/react-core';
import { Totals } from '@medipass/react-core';
import { WithErrorMessage } from '@medipass/react-core';
import { WithLoadingIndicator } from '@medipass/react-core';
import sdk from '@medipass/web-sdk';

import Page from 'legacy/components/account/layout/Page';
import MessageBox from 'legacy/components/account/quotes/MessageBox';
import BackButton from 'legacy/components/BackButton';
import WithAuthentication from 'legacy/components/WithAuthentication';
import { getKeyFromQueryParams } from 'legacy/utils/router';
const StyledCard = styled(Box)`
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 0.5px solid #d3d3d3;
`;
const PracticeLogo = styled.img`
  top: 0px;
  position: absolute;
  right: 5px;
`;
type Props = {};
type State = {
  transactionId?: string;
};
export default class Quote extends React.PureComponent<Props, State> {
  state = {
    transactionId: getKeyFromQueryParams('id'),
  };
  getTransaction = async () => {
    const { transactionId } = this.state;
    if (!transactionId) return;
    return await sdk.transactions.getTransactionByTransactionId(transactionId);
  };
  getHealthFund = async (healthFundId: string) => {
    const healthFund = await sdk.healthfunds.getHealthFunds();
    return _find(healthFund, {
      _id: healthFundId,
    });
  };
  getPractice = async (practiceId: string) => {
    return await sdk.practices.getPractice(practiceId);
  };
  render = () => {
    const { transactionId } = this.state;
    return (
      <WithAuthentication>
        <Page minWidthBreakpoint="mobile" title="Quote details">
          <Loads contextKey={`transaction-${transactionId || ''}`} loadOnMount load={this.getTransaction}>
            {/* @ts-expect-error TS(7031): Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message */}
            {({ error, response: quote, isError, isLoading, isSuccess }) => {
              const claimItems = _get(quote, 'claims[0].claimItems', []);

              const funderCode = _get(quote, 'claims[0].funder.code');

              const hasCompleted = Boolean(_get(quote, 'status') === 'completed');
              const hasHealthFund = Boolean(_get(quote, 'claims[0].healthFundAccount'));

              const practiceLogoUrl = _get(quote, 'practice.logoUrl');

              const responderMessage = _get(quote, 'responderMessage');

              const requesterMessage = _get(quote, 'requesterMessage');

              return (
                <WithLoadingIndicator isActive={isLoading}>
                  <WithErrorMessage isActive={isError} description="Unable to load your transaction." error={error}>
                    <Columns>
                      {/* @ts-expect-error TS(2322): Type '"0"' is not assignable to type 'Flexible<Spa... Remove this comment to see the full error message */}
                      <Columns.Column paddingTop="0" paddingBottom="0" paddingLeft="0">
                        <BackButton to="/account/quotes" />
                      </Columns.Column>
                    </Columns>
                    <Card>
                      {isSuccess && (
                        <Box data-testid="quote-details">
                          {requesterMessage && (
                            <StyledCard>
                              <MessageBox
                                date={format(quote.created, 'DD/MM/YYYY hh:mma')}
                                hasCompleted={false}
                                message={requesterMessage}
                              />
                            </StyledCard>
                          )}
                          {quote.practice && ((hasCompleted && responderMessage) || !hasCompleted) && (
                            <StyledCard>
                              <Box>
                                {responderMessage && (
                                  <MessageBox
                                    date={hasCompleted ? format(quote.quoteSent, 'DD/MM/YYYY hh:mma') : null}
                                    hasCompleted={hasCompleted}
                                    isProvider
                                    message={responderMessage}
                                  />
                                )}
                                <Box marginTop="major-2">
                                  <Box position="relative">
                                    <PracticeLogo
                                      src={practiceLogoUrl}
                                      style={{
                                        width: '70px',
                                        height: '70px',
                                      }}
                                      alt={quote.practice.displayName}
                                    />
                                  </Box>
                                  <label className="label">{quote.practice.displayName}</label>
                                  <Box>{quote.practice.address}</Box>
                                  <Box>
                                    {quote.practice.state} {quote.practice.postCode}
                                  </Box>
                                  {(quote.practice.landline || quote.practice.mobile) && (
                                    <Box>
                                      <Link href={`tel:${quote.practice.landline || quote.practice.mobile}`}>
                                        {quote.practice.landline || quote.practice.mobile}
                                      </Link>
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            </StyledCard>
                          )}
                          {!requesterMessage && !responderMessage && (
                            <StyledCard>
                              {/* @ts-expect-error */}
                              <ServiceDetails
                                created={quote.created}
                                modality={quote.modality}
                                practice={quote.practice}
                                staff={quote.staff}
                              />
                            </StyledCard>
                          )}
                          {hasCompleted && claimItems && (
                            <Box>
                              {hasHealthFund && (
                                <StyledCard>
                                  <HealthFundDetails transaction={quote} />
                                </StyledCard>
                              )}
                              <StyledCard>
                                <Totals
                                  funderCode={funderCode}
                                  serviceItem={claimItems.length === 1 ? claimItems[0] : null}
                                  title="Quote"
                                  transaction={quote}
                                />
                                <Box>
                                  This is an estimate based on provider rates and point in time benefits balance.
                                  Additional procedures, fees or health fund benefit changes will vary final cost.
                                </Box>
                                {claimItems.length > 1 && (
                                  <ServiceItemDetails
                                    funderCode={funderCode}
                                    isQuote
                                    serviceItems={claimItems}
                                    transaction={quote}
                                  />
                                )}
                              </StyledCard>
                              <Loads
                                contextKey={`practice-${quote.practice._id}`}
                                loadOnMount
                                load={() => this.getPractice(quote.practice._id)}
                              >
                                {/* @ts-expect-error TS(7031): Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message */}
                                {({ error, response: practice, isError, isLoading, isSuccess }) => {
                                  const bookingsUrl = _get(practice, 'bookingsUrl');

                                  const practiceNumber = _get(practice, 'landline', _get(practice, 'mobile', ''));

                                  return (
                                    <WithLoadingIndicator isActive={isLoading}>
                                      <WithErrorMessage
                                        isActive={isError}
                                        description="Unable to load practice"
                                        error={error}
                                      >
                                        <StyledCard>
                                          <Box>
                                            <h2>Ready to book?</h2>
                                            If you’re happy with the quote, simply book an appointment with this
                                            provider and after the treatment pay with Tyro Health.
                                            <Link href={bookingsUrl ? bookingsUrl : `tel:${practiceNumber}`}>
                                              <Button palette="secondary" marginTop="major-1" width="100%">
                                                {bookingsUrl ? 'BOOK A TIME' : 'CALL PROVIDER'}
                                              </Button>
                                            </Link>
                                          </Box>
                                        </StyledCard>
                                      </WithErrorMessage>
                                    </WithLoadingIndicator>
                                  );
                                }}
                              </Loads>
                            </Box>
                          )}
                        </Box>
                      )}
                    </Card>
                  </WithErrorMessage>
                </WithLoadingIndicator>
              );
            }}
          </Loads>
        </Page>
      </WithAuthentication>
    );
  };
}
